import { convertPhoneNumberFromMask, convertPhoneNumberInToMask } from "../../helpers/utility";
import { BtnComponent } from "../button";
import { InputField } from "../reactHookFormFields/inputField";
import { MaskField } from "../reactHookFormFields/maskField";


export const ExternalGuest = ({exteralGuests, setExteralGuests, formHandler}) => {


    const appendExternalParticipants = async() => {
        const isValidInputs = await formHandler.trigger(['guest_email', 'guest_phone'])
        const values = formHandler.getValues();
        if(isValidInputs && (values.guest_phone || values.guest_email)){
            let tempArry = []
            if(values.guest_phone){
                const cleanPhoneNumber = convertPhoneNumberFromMask(values.guest_phone)
                tempArry.push({phone: cleanPhoneNumber});
            }
            if(values.guest_email){
                tempArry.push({email: values.guest_email});
            }

            setExteralGuests([...exteralGuests, ...tempArry]);
            formHandler.setValue('guest_email', '');
            formHandler.setValue('guest_phone', '');
        }
    }

    return (
        <>
            <div className="flex gap-2 w-full pb-5">
                <InputField
                    title="Email"
                    name="guest_email"
                    control={formHandler.control}
                    rules={{
                        pattern: {
                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                            message: "Invalid email address"
                        }
                    }}
                    errors={formHandler.errors}
                />
                <MaskField
                    mask="(999) 999-9999"
                    title="Phone"
                    name="guest_phone"
                    control={formHandler.control}
                    rules={{
                        pattern: {
                            value: /^^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/,
                            message: "Please Enter Correct Number",
                        },
                    }}
                    errors={formHandler.errors}
                />
                <BtnComponent text="Add" size="xs" onClick={appendExternalParticipants} btnType='primary_theme' />
            </div>
            {exteralGuests?.length ?
                <div className="flex gap-2 items-center pb-5 flex-wrap">
                    {exteralGuests.map((item, index)=>{
                        return (
                            <div key={index} className="flex gap-2 items-center">
                                <span className="w-full border border-gray rounded bg-gray-100 p-1 px-2 cursor-not-allowed">
                                    {item.phone ? convertPhoneNumberInToMask(item.phone) : item.email}
                                </span>
                            </div>
                        );
                    })}
                </div>
            : null}
        </>
    )
}